/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;



/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/svg-react-loader/~/lodash/_baseTimes.js
 ** module id = 3148
 ** module chunks = 0
 **/